export const rootPath = '/building';
export const viewPath = `${rootPath}/view`;
export const createPath = `${rootPath}/create`;

// Below paths are concatenated after a building id - /building/view/:routeId/upgrade
export const internetPath = '/internet';
export const unitPath = '/units';
export const upgradePath = '/upgrade';
export const securityPath = '/security';
export const satPath = '/satellite';
export const networkPath = '/network';
export const linksPath = '/links';
export const ticketsPath = '/tickets';

export const resourcePath = `${rootPath}/resources`;
export const managerPath = `${resourcePath}/manager`;
export const complexPath = `${resourcePath}/complex`;
export const dtvPath = `${resourcePath}/dtv`;
export const satellitePkgPath = `${resourcePath}/satellite_pkg`;
export const accessControlPath = `${resourcePath}/access_control`;
export const avControlPath = `${resourcePath}/av_control`;
export const firePath = `${resourcePath}/fire`;
export const intrusionPath = `${resourcePath}/intrusion`;
export const remotePowerManagementPath = `${resourcePath}/remote_power_management`;
export const surveillancePath = `${resourcePath}/surveillance`;
export const upgradeResourcePath = `${resourcePath}/upgrade`;

export function getManagerPath(managerId) {
  return `${managerPath}?id=${managerId}`;
}

export function getComplexPath(complexId) {
  return `${complexPath}?id=${complexId}`;
}

export function getBuildingPath(buildingId) {
  return `${viewPath}/${buildingId}`;
}

export function getUnitsPath(buildingId, query = '') {
  return `${viewPath}/${buildingId}${unitPath}${query}`;
}

export function getUnitPath(buildingId, unitId) {
  return `${getUnitsPath(buildingId)}/${unitId}`;
}

export function getBuildingUpgradesPath(buildingId) {
  return `${viewPath}/${buildingId}${upgradePath}`;
}

export function getSatellitePath(buildingId) {
  return `${viewPath}/${buildingId}${satPath}`;
}

export function getSecurityPath(buildingId) {
  return `${viewPath}/${buildingId}${securityPath}`;
}

export function getDot1xPath(buildingId) {
  return `${viewPath}/${buildingId}${internetPath}`;
}

export function getBuildingTicketsPath(buildingId) {
  return `${viewPath}/${buildingId}${ticketsPath}`;
}

export function getBuildingLinksPath(buildingId) {
  return `${viewPath}/${buildingId}${linksPath}`;
}

export function getUpgradesPath(productId, price) {
  const params = new URLSearchParams();
  if (productId) params.set('product_id', productId);
  if (price) params.set('price', price);
  if (!productId && !price) return upgradeResourcePath;
  return `${upgradeResourcePath}?${params.toString()}`;
}
